import { Modal, Button, Collapse } from 'react-bootstrap';
import { useState, useRef, useEffect } from 'react';
import '../App.css';

/*조작법 설명*/ 
function AnswerModal({ show, handleClose }) {

  const [openStates, setOpenStates] = useState({
    one: false,
    two: false,
    three: false,
    four: false,
    four_one: false,
    four_two: false,
    five: false,
    six: false,
  });
  
  const bottomRef = useRef(null);

  useEffect(() => {
    if (bottomRef.current) {
      bottomRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  }, [openStates]); 

  const toggleOpen = (key) => {
    setOpenStates(prev => ({ ...prev, [key]: !prev[key] }));
  };

  return (
    <Modal show={show} onHide={handleClose} backdrop="static" keyboard={false} fullscreen>
      <Modal.Header closeButton>
        <Modal.Title>퀴즈 해설</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <p>각 퀴즈의 해설을 버튼을 눌러 확인해보세요</p>

        {/* ✅ Collapse 예시 */}
        <p className="mt-4"><strong>1. 누구에게 연락하지?</strong></p>
        <Button
          onClick={() => toggleOpen('one')}
          aria-controls="collapse-text-one"
          aria-expanded={openStates.one}
          variant="outline-primary"
          className="mb-2"
        >
          {openStates.one ? '닫기' : '해설 읽기'}
        </Button>
        <Collapse in={openStates.one}>
            <div id="collapse-text-one">
                <div
                className="p-3 border rounded bg-light"
                style={{ whiteSpace: 'pre-wrap' }}
                >
                휴대폰 전화 키패드의 구조는 다음과 같습니다 
                {'\n'}
                {'\n'} 1 2 3
                {'\n'} 4 5 6
                {'\n'} 7 8 9
                {'\n'} * 0 #
                {'\n'}
                {'\n'}여기서 길드장님이 남겨주신 번호를 입력하면 알파벳이 그려집니다
                {'\n'}
                {'\n'}321478965: G
                {'\n'}3214789: C 
                {'\n'}147456369: H
                </div>
            </div>
        </Collapse>



        {/* ✅ Collapse 예시 */}
        <p className="mt-4"><strong>2. 저택 대문</strong></p>
        <Button
          onClick={() => toggleOpen('two')}
          aria-controls="collapse-text-two"
          aria-expanded={openStates.two}
          variant="outline-primary"
          className="mb-2"
        >
          {openStates.two ? '닫기' : '해설 읽기'}
        </Button>
        <Collapse in={openStates.two}>
          <div id="collapse-text-two">
            <div className="p-3 border rounded bg-light">
                열려 있으니 그 틈으로 들어갑시다. 검은 부분을 클릭해보세요
            </div>
          </div>
        </Collapse>

        
        {/* ✅ Collapse 예시 */}
        <p className="mt-4"><strong>3. 태블릿 비밀번호 (보너스 퀴즈)</strong></p>
        <Button
          onClick={() => toggleOpen('three')}
          aria-controls="collapse-text-three"
          aria-expanded={openStates.three}
          variant="outline-primary"
          className="mb-2"
        >
          {openStates.three ? '닫기' : '해설 읽기'}
        </Button>
        <Collapse in={openStates.three}>
          <div id="collapse-text-three">
            <div className="p-3 border rounded bg-light" style={{ whiteSpace: 'pre-wrap' }}>
                저택의 주인은 최신형 기기를 좋아한다고 알려져있습니다. 컴퓨터를 잘 모르는 상대방을 위해, 그는 아스키코드로 힌트를 남겼습니다. 아스키코드(ASCII)란 컴퓨터 등 문자를 쓰는 장치에서 기기가 사람의 문자를 이해할 수 있도록 숫자로 알파벳 등을 나타낸 것입니다
                {'\n'}
                {'\n'}힌트의 숫자들을 아스키코드로 변환해보세요. 태블릿 안에 무엇이 있는지 확인하면 액자에서 얻는 단서가 달라집니다
            </div>
          </div>
        </Collapse>

        
        {/* ✅ Collapse 예시 */}
        <p className="mt-4"><strong>4. 편지</strong></p>
        <Button
          onClick={() => toggleOpen('four')}
          aria-controls="collapse-text-four"
          aria-expanded={openStates.four}
          variant="outline-primary"
          className="mb-2"
        >
          {openStates.four ? '닫기' : '해설 읽기'}
        </Button>
        <Collapse in={openStates.four}>
          <div id="collapse-text-four">
            <div className="p-3 border rounded bg-light" style={{ whiteSpace: 'pre-wrap' }}>
                
                {/* ✅ Collapse 예시 */}
                <p className="mt-4"><strong>(1) 서재에서 </strong></p>
                <Button
                onClick={() => toggleOpen('four_one')}
                aria-controls="collapse-text-four_one"
                aria-expanded={openStates.four_one}
                variant="outline-primary"
                className="mb-2"
                >
                {openStates.four_one ? '닫기' : '해설 읽기'}
                </Button>
                <Collapse in={openStates.four_one}>
                <div id="collapse-text-four_one">
                    <div className="p-3 border rounded bg-light" style={{ whiteSpace: 'pre-wrap' }}>
                편지를 읽기 전, 각 서랍의 내용물을 확인해 보세요. 첫 번째 칸에는 잡동사니가 들어있고, 가운데 칸은 달라붙어 있고, 세 번째 칸에는 중요해 보이는 편지가 들어있습니다
                {'\n'}
                {'\n'}그리고 편지를 읽어 보세요. 띄어쓰기가 잘못돼있는 부분들이 있습니다. 예시로, 첫 번째 줄에서는 '생각이다른'이 잘못 쓰여 있습니다
                {'\n'}
                {'\n'}서랍의 내용물을 떠올려 보세요. 첫 번째는 잡동사니, 가운데는 달라붙어 있고, 세 번째는 중요합니다. 즉 첫 번째 줄에서 중요한 단어는 '다른'입니다
                {'\n'}
                {'\n'}이 방식으로 숨겨진 문장을 찾아보세요
                              </div>
                </div>
                </Collapse>
                
                {/* ✅ Collapse 예시 */}
                <p className="mt-4"><strong>(2) ??에서</strong></p>
                <Button
                onClick={() => toggleOpen('four_two')}
                aria-controls="collapse-text-four_two"
                aria-expanded={openStates.four_two}
                variant="outline-primary"
                className="mb-2"
                >
                {openStates.four_two ? '닫기' : '해설 읽기'}
                </Button>
                <Collapse in={openStates.four_two}>
                    <div id="collapse-text-four_two">
                        <div
                        className="p-3 border rounded bg-light"
                        style={{ whiteSpace: 'pre-wrap' }}
                        >
                        편지에 숨겨진 문장은 '다른 게 있는 곳 비밀이 있어'입니다
                        {'\n'}
                        {'\n'}저택에는 총 5개의 장소가 있고, 그중 단 한 곳만 다른 방에 비해 먼지가 덜 쌓여있고 살펴볼 수 있는 것이 적습니다
                        {'\n'}
                        {'\n'}그곳에서 비밀을 찾아보세요. 좌우를 살펴보는 것도 도움이 되겠네요
                        </div>
                    </div>
                </Collapse> 
              </div>
          </div>
        </Collapse>
        
        {/* ✅ Collapse 예시 */}
        <p className="mt-4"><strong>+ 퇴근을 하고 싶다면</strong></p>
        <Button
          onClick={() => toggleOpen('five')}
          aria-controls="collapse-text-five"
          aria-expanded={openStates.five}
          variant="outline-primary"
          className="mb-2"
        >
          {openStates.five ? '닫기' : '해설 읽기'}
        </Button>
        <Collapse in={openStates.five}>
          <div id="collapse-text-five">
            <div className="p-3 border rounded bg-light">
                해설 페이지를 닫고 집으로 가보세요. 퇴근까지 시간이 얼마나 걸렸는지 알 수 있습니다
            </div>
          </div>
        </Collapse>

        <div ref={bottomRef}/>
      </Modal.Body>

      <Modal.Footer>
        <Button variant="primary" onClick={handleClose}>
          확인
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default AnswerModal;
